import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useState } from 'react';
import { isValidNumber, strToInteger } from '@/utils/numbers';
import { humanize, titleize } from '@/utils/strings';
import { decodeColors } from '@/utils/colors';
import { Select, Label } from '@/components/FormElements';
import Button from '@/components/Button';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import ColorPicker from '@/components/Editor/Form/fields/common/ColorPicker';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PointStylesIcon = function PointStylesIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2203 7.99999C15.2203 7.58222 15.559 7.24356 15.9767 7.24356H22.9301C23.3479 7.24356 23.6866 7.58222 23.6866 7.99999C23.6866 8.41776 23.3479 8.75642 22.9301 8.75642H15.9767C15.559 8.75642 15.2203 8.41776 15.2203 7.99999Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.313324 8.0078C0.313324 7.59004 0.65199 7.25137 1.06976 7.25137H8.02316C8.44093 7.25137 8.7796 7.59004 8.77959 8.0078C8.7796 8.42557 8.44093 8.76423 8.02316 8.76423H1.06976C0.65199 8.76423 0.313324 8.42557 0.313324 8.0078Z",
      fill: "#C3C9D1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.48853 4.25587C6.42069 6.3237 6.42069 9.67632 8.48853 11.7441C10.5564 13.812 13.909 13.812 15.9768 11.7441C18.0446 9.67632 18.0446 6.3237 15.9768 4.25587C13.909 2.18803 10.5564 2.18803 8.48853 4.25587Z",
      fill: "black"
    })]
  }));
};

PointStylesIcon.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const DEFAULT_POINT_RADIUS = -1;
const DEFAULT_POINT_STYLE = 'circle';
const POINT_SIZE_OPTIONS = [{
  label: 'Default',
  value: -1
}, {
  label: 'None',
  value: 0
}, {
  label: 'Small',
  value: 2
}, {
  label: 'Medium',
  value: 3
}, {
  label: 'Large',
  value: 5
}, {
  label: 'Extra Large',
  value: 10
}];
const POINT_STYLE_OPTIONS = ['circle', 'cross', 'crossRot', 'dash', 'line', 'rect', 'rectRounded', 'rectRot', 'star', 'triangle'];

const EditorFieldsPointStyles = _ref => {
  let {
    nameSpace,
    label = 'Point Styles',
    variant,
    pointRadius,
    pointStyle,
    pointBackgroundColor,
    colorPallet,
    defaults = {},
    disabledPointStyles = [],
    hasPointRadius = true,
    openButtonVariant,
    onChange
  } = _ref;
  const {
    0: updatedAt,
    1: setUpdatedAt
  } = useState(Date.now());
  const pointRadiusValue = pointRadius ?? defaults.pointRadius ?? DEFAULT_POINT_RADIUS;
  const pointStyleValue = pointStyle ?? defaults.pointStyle ?? DEFAULT_POINT_STYLE;
  const pointBackgroundColorValue = pointBackgroundColor ?? (defaults === null || defaults === void 0 ? void 0 : defaults.pointBackgroundColor);

  const handleDelete = () => {
    // Reset all values to null
    onChange({
      pointRadius: null,
      pointStyle: null,
      pointBackgroundColor: null
    });
    setUpdatedAt(Date.now());
  }; // Some charts may not support certain point styles
  // Filter out any disabled point styles
  // e.g. 'cross', 'line' is not supported in line charts


  const pointStyleOptions = POINT_STYLE_OPTIONS.filter(style => !disabledPointStyles.includes(style));
  const pointRadiusFieldId = `${nameSpace}-pointRadius`;
  const pointStyleFieldId = `${nameSpace}-pointStyle`;
  const colorPickerFieldId = `${nameSpace}-color`;
  const isModified = variant === 'active';
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: label,
    variant: variant,
    openButtonVariant: openButtonVariant,
    activeState: /*#__PURE__*/_jsx(PointStylesIcon, {}),
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx({
        [parentStyles.formField__grid]: hasPointRadius,
        ['mb-6']: !hasPointRadius
      }),
      children: [hasPointRadius ? /*#__PURE__*/_jsx(Label, {
        forInput: pointRadiusFieldId,
        text: "Size",
        className: parentStyles.formField,
        children: /*#__PURE__*/_jsx(Select, {
          id: pointRadiusFieldId,
          defaultValue: pointRadiusValue,
          onChange: evt => {
            const value = strToInteger(evt.currentTarget.value);
            onChange({
              pointRadius: isValidNumber(value) && value >= 0 ? value : null
            });
          },
          children: POINT_SIZE_OPTIONS.map(option => /*#__PURE__*/_jsx("option", {
            value: option.value,
            children: option.label
          }, `${nameSpace}-${option.label}`))
        })
      }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(Label, {
        forInput: pointStyleFieldId,
        text: "Style",
        className: parentStyles.formField,
        children: /*#__PURE__*/_jsx(Select, {
          id: pointStyleFieldId,
          defaultValue: pointStyleValue,
          onChange: evt => {
            onChange({
              pointStyle: evt.currentTarget.value
            });
          },
          children: pointStyleOptions.map(value => /*#__PURE__*/_jsx("option", {
            value: value,
            children: titleize(humanize(value))
          }, `${nameSpace}-${value}`))
        })
      })]
    }), /*#__PURE__*/_jsx(ColorPicker, {
      label: "Point Color",
      id: colorPickerFieldId,
      defaultValue: decodeColors(pointBackgroundColorValue).shift(),
      colorPallet: colorPallet,
      className: styles.colorPicker,
      onChange: color => onChange({
        pointBackgroundColor: typeof color === 'string' ? color : null
      })
    }, colorPickerFieldId), isModified ? /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "delete",
      className: styles.deleteButton,
      onClick: () => handleDelete(),
      children: "Reset to default"
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  }, updatedAt);
}; // Check if point styles have been modified


export const checkPointStylesModified = (styles, defaults) => {
  const defaultPointRadius = (defaults === null || defaults === void 0 ? void 0 : defaults.pointRadius) ?? DEFAULT_POINT_RADIUS;
  const defaultPointStyle = (defaults === null || defaults === void 0 ? void 0 : defaults.pointStyle) ?? DEFAULT_POINT_STYLE;
  return typeof styles.pointStyle !== 'undefined' && styles.pointStyle !== defaultPointStyle || typeof styles.pointRadius !== 'undefined' && styles.pointRadius !== defaultPointRadius || typeof styles.pointBackgroundColor !== 'undefined' && styles.pointBackgroundColor !== (defaults === null || defaults === void 0 ? void 0 : defaults.pointBackgroundColor);
};
export default EditorFieldsPointStyles;